/*
 * Import common js to use common function in this javascript file
 */
import { deleteConfirmationAlert } from "./common";
import { searchByTableColumns } from "./common";

/**
 * Report store
 */
setTimeout(function(){
    window.$(".reportforms #start_date").datetimepicker({
        timepicker: true,
        format: DATE_TIME_FORMAT,
        step: 15,
        dayOfWeekStart: 1,
        onShow: function (ct) {
            this.setOptions({
                
            })
        },
        onChangeYear: function (dateText, inst) {
            var date = moment(dateText).format("DD/MM/YYYY HH:mm");
            window.$(inst).val(date);
        },
        onChangeMonth: function (dateText, inst) {
            var date = moment(dateText).format("DD/MM/YYYY HH:mm");
            window.$(inst).val(date);
        }
    });
    window.$(".reportforms #end_date").datetimepicker({
        timepicker: true,
        format: DATE_TIME_FORMAT,
        step: 15,
        dayOfWeekStart: 1,
        onShow: function (ct) {
            this.setOptions({
            })
        },
        onChangeYear: function (dateText, inst) {
            var date = moment(dateText).format("DD/MM/YYYY HH:mm");
            window.$(inst).val(date);
        },
        onChangeMonth: function (dateText, inst) {
            var date = moment(dateText).format("DD/MM/YYYY HH:mm");
            window.$(inst).val(date);
        }
    });
},1000)
 
window.$(".saveReport").on('click', function(e) {
    e.preventDefault();
    window.$(".error").html('');
    window.toastr.remove();
    window.$('.saveReport').attr('disabled', 'disabled');
    window.axios({
            method: "post",
            url: window.$(".reportForm").attr('action'),
            data: window.$(".reportForm").serialize(),
        })
        .then(function(response) {
            window.toastr.success(response.data.message, response.statusText);
            setTimeout(function() {
                window.location = response.data.redirectTo;
            }, 1000);

        })
        .catch(function(error) {
            window.$('.saveReport').removeAttr('disabled');
            if (error.response.status == 400) {
                window.$.each(error.response.data, function(key, value) {
                    window.$('#' + key + '-error').text(value[0]);
                });
            } else if (error.response.status == 500) {
                window.toastr.error(error.response.data.message, error.response.statusText);
            }
        });
    return false;
});

/**
 * Report update
 */
window.$(".updateReport").on('click', function(e) {
    e.preventDefault();
    window.$(".error").html('');
    window.toastr.remove();
    window.$('.updateReport').attr('disabled', 'disabled');
    window.axios({
            method: "PUT",
            url: window.$(".reportUpdateForm").attr('action'),
            data: window.$(".reportUpdateForm").serialize(),
        })
        .then(function(response) {
            window.toastr.success(response.data.message, response.statusText);
            setTimeout(function() {
                window.location = response.data.redirectTo;
            }, 1000);
        })
        .catch(function(error) {
            window.$('.updateReport').removeAttr('disabled');
            if (error.response.status == 400) {
                window.$.each(error.response.data, function(key, value) {
                    window.$('#' + key + '-error').text(value[0]);
                });
            } else if (error.response.status == 500) {
                window.toastr.error(error.response.data.message, error.response.statusText);
            }
        });
    return false;
});

/**
 * Report listing
 */

var table = window.$('.report_management #reportMngmt').DataTable({
    "oLanguage": DATATABLE_LANGUAGE_OPTIONS,
    "aLengthMenu": DATATABLE_MENU_LENGTH_OPTIONS,
    processing: true,
    serverSide: true,
    "ajax": {
        "url": window.$(".report_management #reportMngmt").attr('link'),
        data: function(d) {
            d.report_type = $('#report_type_filter').val()
        }
    },
    columns: [
        { data: 'id', name: 'id', "visible": false },
        { data: 'name', name: 'name' },
        { data: 'type', name: 'type' },
        { data: 'action', name: 'action', orderable: false, searchable: false },
    ]
});

window.$(document).on('change', '#report_type_filter ', function(e) {
    table.draw();
});

// Search in datatables of report
window.$(document).ready(function() {
    // Setup - add a text input to each footer cell
    var excluded_columns = [3];
    searchByTableColumns(table, '.report_management #reportMngmt', excluded_columns);
});
function formatOption(option) {
    var $option = $(
        '<div class="table-heading">' + option.text + '</div><small class="text-secondary">' + option.title + '</small>'
    );
    return $option;
};
window.addEventListener('DOMContentLoaded', (event) => {
    let areaOptions = [];
    $("#areaOption option").each(function(){
      areaOptions.push($(this).val());
    });
    window.$('#areaOption').select2({
        placeholder: DROPDOWN_MULTI_SELECT_PLACEHOLDER,
        closeOnSelect: false,
        debugger: true,
        templateResult: formatOption
    }).on('change', function (e) {
        var data = $("option:selected", this).text();
        if (data) {
            $(this).next('span').find('.select2-search--inline').hide();
        } else {
            $(this).next('span').find('.select2-search--inline').show();
        }
    });
    $("#areaOption").val(areaOptions).trigger('change');

    // AVAILABLE DATA
    let availbaleData = [];
    $("#availableData option").each(function(){
        availbaleData.push($(this).val());
    });
    let s2 = window.$('#availableData,#availableDataEdit').select2({
        placeholder: DROPDOWN_MULTI_SELECT_PLACEHOLDER,
        closeOnSelect: false,
        debugger: true,
        templateResult: formatOption,
        tags: true,
    }).on('change', function (e) {
        var data = $("option:selected", this).text();
        if (data) {
            $(this).next('span').find('.select2-search--inline').hide();
        } else {
            $(this).next('span').find('.select2-search--inline').show();
        }
    });
    let statusData = [];
    $("#reservationStatus option").each(function(){
        if($(this).val() == 'confirmed' || $(this).val() == 'unconfirmed'){
            statusData.push($(this).val());
        }   
    });
    window.$('#reservationStatus').select2({
        placeholder: DROPDOWN_MULTI_SELECT_PLACEHOLDER,
        closeOnSelect: false,
        debugger: true,
        templateResult: formatOption
    }).on('change', function (e) {
        var data = $("option:selected", this).text();
        if (data) {
            $(this).next('span').find('.select2-search--inline').hide();
        } else {
            $(this).next('span').find('.select2-search--inline').show();
        }
    });
    $("#reservationStatus").val(statusData).trigger('change');
    s2.next().children().children().children().sortable({
        containment: 'parent', stop: function (event, ui) {
            ui.item.parent().children('[title]').each(function () {
                var title = $(this).attr('title');
                var original = $( 'option:contains(' + title + ')', s2 ).first();
                original.detach();
                s2.append(original)
            });
            s2.change();
        }
    });
    $("ul.select2-selection__rendered").sortable({
        containment: 'parent'
    });
    $("#availableData").val(availbaleData).trigger('change');
    
});



/**
 * view reservation report
 */
var columns = [];
if (window.$("#displayColumns").length == 1) {
    columns = JSON.parse(window.$("#displayColumns").val());
}

var viewReportTable = window.$('.viewReportTable').DataTable({
    "oLanguage": DATATABLE_LANGUAGE_OPTIONS,
    "aLengthMenu": DATATABLE_MENU_LENGTH_OPTIONS,
    processing: true,
    serverSide: true,
    "ajax": {
        "url": window.$("#viewReportTableRoute").val()
    },
    columns: columns
});

window.$(document).on('click','.deleteReport',function(e){
    var currentObj = window.$(this);
    // Call method for delete confirmation
    var promise = deleteConfirmationAlert();
    promise.then(function (result) {
        e.preventDefault();
        window.axios({
            method: "DELETE",
            url: currentObj.attr('link')
        })
            .then(function (response) {
                window.toastr.success(response.data.message, response.statusText);
                window.location = currentObj.attr('redirectLink');
            })
            .catch(function (error) {
                window.toastr.error(error.response.data.message, error.response.data.statusText);

            });
        return false;
    }).catch(function (err) {
        console.log(err);
        return false;
    });
});
window.$(document).on('click', '.deleteReports', function (e) {
    var currentObj = window.$(this);
    // Call method for delete confirmation
    var promise = deleteConfirmationAlert();
    promise.then(function (result) {
        // If confirmation true, do action for delete
        var myTable = window.$('.report_management #reportMngmt').DataTable({
            bRetrieve: true,
            ajax: window.$('.report_management #reportMngmt').attr('link')
        });
        e.preventDefault();
        window.axios({
            method: "DELETE",
            url: currentObj.attr('link')
        })
            .then(function (response) {
                myTable.ajax.reload();
                window.toastr.success(response.data.message, response.statusText);
            })
            .catch(function (error) {
                window.toastr.error(error.response.data.message, error.response.data.statusText);

            });
        return false;

    }).catch(function (err) {
        console.log(err);
        return false;
    });

});